import { SignificantParty } from "../components/significantParties/significantPartiesModel";
import { multiFile } from "./UploadField";

function allFilesHaveUniqueNames(
  files: File[],
  values: any,
  field: string,
  acceptedFiles?: multiFile[]
): boolean {
  const fileNames = new Set(files.map(file => file.name));
  if (!(fileNames.size === files.length)) {
    return false;
  }
  if (acceptedFiles && acceptedFiles.length > 0) {
    for (const file of files) {
      if (
        acceptedFiles.some(acceptedFile => acceptedFile.fileName === file.name)
      ) {
        return false;
      }
    }
  }
  let currentlyUploaded = allUploadedFiles(values, field);
  // console.log(currentlyUploaded);
  if (currentlyUploaded.length > 0) {
    for (const file of files) {
      if (
        currentlyUploaded.some((fileName: string) => fileName === file.name)
      ) {
        return false;
      }
    }
  }

  return true;
}

export default allFilesHaveUniqueNames;

function allUploadedFiles(values: any, field: string) {
  const uploadedFileNames: string[] = [];

  values.significantParties.forEach(
    (party: SignificantParty, index: number) => {
      if (
        party.proofOfAddressFilename &&
        party.proofOfAddressFilename.length > 0 &&
        field !== `significantParties.${index}.proofOfAddressFilename`
      ) {
        uploadedFileNames.push(party.proofOfAddressFilename);
      }
    }
  );

  if (
    values.corporate.authorizedCapital.proofOfSourceOfFundsFileName &&
    values.corporate.authorizedCapital.proofOfSourceOfFundsFileName.length >
      0 &&
    field !== "corporate.authorizedCapital.proofOfSourceOfFundsFileName"
  ) {
    uploadedFileNames.push(
      values.corporate.authorizedCapital.proofOfSourceOfFundsFileName
    );
  }

  if (
    values.corporate.authorizedCapital.supportingDocuments &&
    values.corporate.authorizedCapital.supportingDocuments.length > 0 &&
    field !== "corporate.authorizedCapital.supportingDocuments"
  ) {
    values.corporate.authorizedCapital.supportingDocuments.forEach(
      (doc: multiFile) => {
        if (doc.fileName && doc.fileName.length > 0) {
          uploadedFileNames.push(doc.fileName);
        }
      }
    );
  }

  if (
    Array.isArray(values.documentsUpload) &&
    values.documentsUpload.length > 0 &&
    values.documentsUpload[0].documentTypesID
  ) {
    values.documentsUpload.forEach(
      (doc: { fileName: string }, index: number) => {
        if (
          doc.fileName &&
          doc.fileName.length > 0 &&
          field !== `documentUpload.${index}`
        ) {
          uploadedFileNames.push(doc.fileName);
        }
      }
    );
  }

  return uploadedFileNames;
}
